import { GET_FILES_SUCCESS } from './file.type';

const initialState = {
    files: [],
};

export const fileReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FILES_SUCCESS:
            return {
                ...state,
                files: action.payload,
            };

        default:
            return state;
    }
};
